'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _GroupContactsListItem = require('components/GroupContacts/GroupContactsListItem/GroupContactsListItem');

var _GroupContactsListItem2 = _interopRequireDefault(_GroupContactsListItem);

var _List = require('components/List/List');

var _List2 = _interopRequireDefault(_List);

var _SelectableList2 = require('components/SelectableList/SelectableList');

var _SelectableList3 = _interopRequireDefault(_SelectableList2);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./GroupContactsList.scss');

var GroupContactsList = (_class = (_temp = _class2 = function (_SelectableList) {
  (0, _inherits3.default)(GroupContactsList, _SelectableList);

  function GroupContactsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, GroupContactsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = GroupContactsList.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsList)).call.apply(_ref, [this].concat(args)));

    _this.setConfig({
      propsField: 'contacts',
      updateFn: _this.props.updateCheckedGroupContacts,
      checkedItemsPropsField: 'checkedGroupContacts'
    });
    return _this;
  }

  (0, _createClass3.default)(GroupContactsList, [{
    key: 'onRowClick',
    value: function onRowClick(item) {
      this.toggleItemChecked(item.id);
    }
  }, {
    key: 'onSelectionChange',
    value: function onSelectionChange(checkedItems) {
      this.props.onSelectionChange(checkedItems);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          contacts = _props.contacts,
          loading = _props.loading,
          onDelete = _props.onDelete,
          checkedGroupContacts = _props.checkedGroupContacts;


      if (loading) {
        return _react2.default.createElement(_Loader2.default, { alignCenter: true });
      }

      return _react2.default.createElement(
        _List2.default,
        { className: (0, _bind2.default)(styles.list, className) },
        contacts.map(function (contact) {
          return _react2.default.createElement(_GroupContactsListItem2.default, {
            key: contact.id,
            contact: contact,
            checked: checkedGroupContacts[contact.id],
            onClick: _this2.onRowClick,
            onDelete: onDelete
          });
        })
      );
    }
  }]);
  return GroupContactsList;
}(_SelectableList3.default), _class2.propTypes = {
  checkedGroupContacts: _propTypes2.default.object,
  className: _propTypes2.default.string,
  contacts: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  onDelete: _propTypes2.default.func,
  onSelectionChange: _propTypes2.default.func,
  updateCheckedGroupContacts: _propTypes2.default.func
}, _class2.defaultProps = {
  checkedGroupContacts: {},
  contacts: [],
  onDelete: _noop3.default,
  onSelectionChange: _noop3.default,
  updateCheckedGroupContacts: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onRowClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onRowClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSelectionChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelectionChange'), _class.prototype)), _class);
exports.default = GroupContactsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupContacts/GroupContactsList/GroupContactsList.js
// module id = 2015
// module chunks = 1